<template>
    <div>
        <!-- Tabel Sarana -->
        <div class="card">
            <div class="card-header">
                <div class="col-12 col-lg-12">
                    <div class="row">
                        <div class="col-6 col-lg-6 order-1 order-lg-1">
                            <h5
                                style="
                                    vertical-align: middle !important;
                                    float: left !important;
                                "
                            >
                                Data Ceklog Sarana (Light Vihicle)
                                
                            </h5>
                        </div>
                        <div class="col-6 col-lg-6 order-2 order-lg-2">
                            <div class="col-12 col-lg-12">
                                <div class="d-flex justify-content-end">
                                    <a href="/sarana/ceklog/show" target="_blank"
                                        class="btn btn-sm btn-primary me-2"
                                        type="button"
                                    >
                                        <span class="tf-icons bx bx-plus"></span
                                        >&nbsp; Tambah Sarana
                                        </a>
                                    <button
                                        ref="updateBtn"
                                        id="showToastPlacement"
                                        class="btn btn-sm btn-warning"
                                        type="button"
                                        @click="getCeklog(halaman)"
                                    >
                                        <span
                                            class="tf-icons bx bx-refresh"
                                        ></span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="table-responsive text-nowrap">
                <table class="table table-hover">
                    <caption class="ms-4" v-if="ceklogs.total > 0">
                        Showing
                        {{
                            ceklogs.from
                        }}
                        to
                        {{
                            ceklogs.to
                        }}
                        of
                        {{
                            ceklogs.total
                        }}
                        Cek Logs
                    </caption>
                    <thead>
                        <tr>
                            <th>Nomor</th>
                            <th>Nomor Lambung</th>
                            <th>Merek - Type</th>
                            <th>Kilometer Unit</th>
                            <th>Hari & Tanggal</th>
                            <th>Jam</th>
                            <th>Pengemudi</th>
                        </tr>
                    </thead>
                    <tfoot>
                        <tr>
                            <th>Nomor</th>
                            <th>Nomor Lambung</th>
                            <th>Merek - Type</th>
                            <th>Kilometer Unit</th>
                            <th>Hari & Tanggal</th>
                            <th>Jam</th>
                            <th>Pengemudi</th>
                        </tr>
                    </tfoot>
                    <tbody class="table-border-bottom-0">
                        <tr v-for="(a, b) in ceklogs.data" >
                            
                            <td>
                                <strong>{{ ceklogs.from + b }}</strong>
                                &nbsp;
                                <a :href="'/sarana/ceklog/'+a.kodeUnit+'/edit'" target="_blank"
                                        class="btn btn-xs btn-primary me-2"
                                        type="button"
                                    >
                                        <span class="tf-icons bx bx-show"></span
                                        >&nbsp; Lihat
                                        </a>
                            </td>
                            <td>{{ a.noLambung }}</td>
                            <td>
                            {{ a.merkType }}
                                
                            </td>
                            <td>{{ a.kilometerUnit }}</td>
                            <td>{{ a.hari }} , {{ moment(a.tanggal).format("DD MMMM YYYY") }}</td>
                            <td>{{ a.jam }}</td>
                            <td>{{ a.driver }}</td>
                        </tr>
                        <tr v-if="ceklogs.total == 0">
                            <td>Tidak Ada Data</td>
                        </tr>
                    </tbody>
                </table>
                <div style="margin-top: 100px;">

                </div>
            </div>
            <div class="card-footer">
                <Bootstrap5Pagination
                    :data="ceklogs"
                    @pagination-change-page="getCeklog"
                />
            </div>
        </div>
        <!--/ Hoverable Table rows -->
    </div>
</template>

<script>
import axios from "axios";
import { Bootstrap5Pagination } from "laravel-vue-pagination";
import { ref } from "vue";
import moment from "moment";

const focusRef = ref(null);

export default {
    components: {
        Bootstrap5Pagination,
    },
    mounted() {
        this.csrfTokens = this.tokens;
        this.getCeklog(this.halaman);
    },
    data() {
        return {
            moment: moment,
            ceklogs: {},
            halaman: 1,
            csrfTokens: "",
        };
    },
    props: ["tokens"],
    methods: {
        toast() {
            $("#myToast").toast("show");
        },
        getCeklog(page) {
            if (page != undefined) {
                this.halaman = page;
            }
            axios
                .get("/sarana/ceklog/create?page=" + this.halaman)
                .then((response) => {
                    var ceklogs = response.data;
                    if (ceklogs != null) {
                        this.ceklogs = ceklogs;
                    }
                });
        },
        doEmits() {
            this.getCeklog(this.halaman);
        },
        inputFocusEvent() {
            var thisFocus = this;
            var myOffcanvas = document.getElementById("offcanvasBoth");

            thisFocus.$refs.focusRef.initDatas();
            var bsOffcanvas = new bootstrap.Offcanvas(myOffcanvas);

            bsOffcanvas.toggle();
        },
        
    },
};
</script>
